<template>
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical form">
    <Form @submit="onBeforeSubmit" :validation-schema="validationSchema" ref="form" :initial-values="formValues">
      <div class="uk-modal-header form-header">
        <span class="uk-text-bold uk-text-large">{{ position && position.id ? "役職編集" : "役職新規作成" }}</span>
      </div>
      <div class="uk-modal-body">
        <FormError :errors="globalErrors" />
        <div class="field">
          <Field name="name" v-slot="{ field }">
            <FieldLabel title="役職名" :required="true" />
            <input class="uk-input" type="text" v-bind="field" />
          </Field>
          <FieldError name="name" />
        </div>
      </div>
      <div class="uk-modal-footer uk-text-right form-action">
        <div>
          <ActionButton title="戻る" class="uk-modal-close" toggleTarget=".position-form-modal" />
        </div>
        <div class="form-action-main">
          <ActionButton title="確定" color="primary" type="submit" :disabled="processing" />
          <ActionButton v-if="position" title="削除" @click="onDeleteButtonClick" color="warn" />
        </div>
      </div>
    </Form>
  </div>
</template>
<style lang="scss" scoped>
@include modal-form;
</style>
<script lang="ts">
import { Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import FormMixin from "../../helpers/mixins/form";
import { ClientApi, IdName as Position } from "../../autogen";
import { Field, Form } from "vee-validate";
import FieldLabel from "../atoms/FieldLabel.vue";
import * as yup from "yup";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import ActionButton from "@/components/atoms/ActionButton.vue";
type FormValues = { name: string };
@Options({
  components: { Field, Form, FieldLabel, FieldError, ActionButton, FormError }
})
export default class PositionForm extends FormMixin {
  @Prop({ type: Object }) position?: Position;
  formName = "役職";
  formValues: FormValues = {
    name: ""
  };
  validationSchema!: yup.AnyObjectSchema;
  beforeCreate() {
    this.validationSchema = yup.object({
      name: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "役職名" }))
    });
  }
  beforeMount() {
    this.formValues = this.position
      ? {
          name: this.position.name
        }
      : { name: "" };
  }
  async onBeforeSubmit(values: FormValues) {
    await this.onSubmit(async () => {
      if (this.position) {
        await new ClientApi().updatePosition({
          positionId: this.position!.id,
          createPositionRequest: values
        });
      } else {
        await new ClientApi().createPosition({
          createPositionRequest: values
        });
      }
      this.$emit("submitted");
    });
  }
  async onDeleteButtonClick() {
    this.onDelete(async () => {
      await new ClientApi().deletePosition({
        positionId: this.position!.id
      });
    });
  }
}
</script>
